module.exports = __webpack_public_path__ + "static/media/level-oxford-3000.a1f088e4.png";